/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Comparison_Product_Hunt_Rows_Moment_RightInputs */

const en_directory_comparison_product_hunt_rows_moment_right = /** @type {(inputs: Directory_Comparison_Product_Hunt_Rows_Moment_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The daily launch cycle`)
};

const zh_directory_comparison_product_hunt_rows_moment_right = /** @type {(inputs: Directory_Comparison_Product_Hunt_Rows_Moment_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每日发布周期`)
};

/**
* | output |
* | --- |
* | "The daily launch cycle" |
*
* @param {Directory_Comparison_Product_Hunt_Rows_Moment_RightInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_comparison_product_hunt_rows_moment_right = /** @type {((inputs?: Directory_Comparison_Product_Hunt_Rows_Moment_RightInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Comparison_Product_Hunt_Rows_Moment_RightInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_comparison_product_hunt_rows_moment_right(inputs)
	return zh_directory_comparison_product_hunt_rows_moment_right(inputs)
});
export { directory_comparison_product_hunt_rows_moment_right as "directory.comparison.product_hunt.rows.moment.right" }